import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ResizeAware from 'react-resize-aware';
import DataHaulGrid from '../../components/crosstab/DataHaulGrid/DataHaulGrid';
import { DATAHAUL_CONSTANT, FLEX_STUDY_TAG,
  DATAHAUL_FEATUREID } from '../../constants';
import * as studyActions from '../../actions/studyActions';
import CommonStudySelector from '../../components/common/CommonStudySelector';
import enlargeIcon from '../../images/enlarge-icon_48-67-93.png';
import enlargeHoverIcon from '../../images/enlarge-icon_brown.png';
import basesIcon from '../../images/bases-small-icon_blue.png';
import basesHoverIcon from '../../images/bases-small-icon.png';
import basesDisabledIcon from '../../images/bases_icon_disabled.png';
import columnsIcon from '../../images/columns_icon_normal_state.png';
import columnsHoverIcon from '../../images/columns-icon.png';
import columnsDisabledIcon from '../../images/columns_icon_disabled.png';
import runIcon from '../../images/run_report_icon_normal.png';
import runHoverIcon from '../../images/run_report_icon_hover.png';
import runDisabledIcon from '../../images/run_report_icon_disabled.png';
import Modal from '../common/Modal/Modal';
import GenericButton from '../common/GenericButton';
import SmartSearch from '../common/SmartSearch/SmartSearch';
import { filterStudies } from '../../util/CommonUtils';

const modalDataHaulWariningStyle = {
  width: '30%',
  height: '40px',
  left: '35%',
  top: '25%',
};

class DataHaulSmartSearchEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studies: props.studies ? filterStudies(this.props.studies, FLEX_STUDY_TAG) : [],
      defaultStudy: {},
      showWeightType: true,
      isTagInputExpanded: true,
      baseBtnDisabled: true,
      colBtnDisabled: true,
    };
    this.smartSearchBox = React.createRef();
  }

  componentDidMount() {
    this.onMount();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.studies && nextProps.studies !== this.props.studies) {
      this.setState(() => ({ studies: filterStudies(nextProps.studies, FLEX_STUDY_TAG) }));
    }

    if (nextProps.datahaulStudy
      && nextProps.datahaulStudy !== this.props.datahaulStudy) {
      this.setState(() => ({
        defaultStudy: nextProps.datahaulStudy,
      }));
    }
    if (nextProps.kpiInfo !== this.props.kpiInfo) {
      if (nextProps.kpiInfo && nextProps.kpiInfo.intab) {
        this.setState({
          baseBtnDisabled: false,
          colBtnDisabled: false,
        });
      } else {
        this.setState({
          baseBtnDisabled: true,
          colBtnDisabled: true,
        });
      }
    }
  }

  onMount = () => {
    if (this.props.datahaulStudy) {
      this.setState(() => ({ defaultStudy: this.props.datahaulStudy }));
    }
  }

  getCrosstabTitle = () =>
    this.crosstabViewer && this.crosstabViewer.current
      ? this.crosstabViewer.current.getCrosstabTitle()
      : 'untitled';

  setSelectedStudy = (selectedStudy, updatedWeightType) => {
    this.setState(() => ({ actualWeightType: selectedStudy.wt }));
    this.props.handleStudyChange(selectedStudy, updatedWeightType);
  }

  handleDataHaulGridResize = dimensions => {
    this.setState({
      dataHaulGridWidth: dimensions.width,
      dataHaulGridHeight: dimensions.height,
    });
  };

  handleChangeWeightType = weightType => {
    const updatedStudyItem = { ...this.state.defaultStudy, wt: weightType };
    this.props.studyActions.updateModuleStudy('datahaul', updatedStudyItem);
  }

  handleCrosstabEdit = (idKey, dataSmartSearch) => {
    this.smartSearchBox.current
      .editCrosstabGrid(idKey, dataSmartSearch);
  };

  /**
   * To update target grid of DataHaul
   */
  handleDataHaulMove = targetGrid => {
    const {
      expressionFormed,
      objectsAdded,
      selectedCategoryID,
      tags,
    } = this.smartSearchBox.current.state;
    this.smartSearchBox.current.handleSelectedIndexState();
    const { loginResponse, activeAccountId, datahaulStudy, gridData } = this.props;
    const objSmartSearchArray = [
      { expressionFormed, objectsAdded, selectedCategoryID, tags },
    ];
    if (datahaulStudy && expressionFormed.length > 0) {
      const selectedNames = [objectsAdded.reduce((acc, { shortText }) => `${acc} ${shortText}`, '')];
      const sampleWeightedParams = {
        token: loginResponse.data.token,
        uid: loginResponse.data.uid,
        accountId: activeAccountId,
        productNo: datahaulStudy.pn,
        weightType: this.props.datahaulWeightTypes.wt,
        divisor: this.props.datahaulWeightTypes.dv,
        gridData:
          gridData[targetGrid] &&
            (targetGrid !== 'TargetDataGrid' && targetGrid !== 'BaseDataGrid')
            ? gridData[targetGrid]
            : [],
        expressionList: [expressionFormed.join(' ')],
        originalNames: selectedNames,
        selectedNames,
        targetGrid,
        objSmartSearchArray,
      };
      this.props.getSampleWeighted(sampleWeightedParams);
      this.smartSearchBox.current.resetAll();
      this.setState({ baseBtnDisabled: true, colBtnDisabled: true });
    }
  };

  /**
   * Method to handle Data Haul Run button.
   */
  handleRunDataHaul = () => {
    const { DataHaulBasesDataGrid, DataHaulColumnsDataGrid } = this.props.gridData;
    if (DataHaulBasesDataGrid.length > 1) {
      this.modalDataHaulBaseWarining.show();
    } else if (DataHaulColumnsDataGrid.length > 10) {
      this.modalDataHaulColumnWarining.show();
    } else {
      this.props.runDataHaul();
    }
  };

  resetAll = () => {
    this.setState({ baseBtnDisabled: true, colBtnDisabled: true });
  }

  getSampleWeightedDatahaul = weightList => {
    const { loginResponse, activeAccountId, datahaulStudy, crosstab } = this.props;
    let sampleWeightedParams = {
      token: loginResponse.data.token,
      uid: loginResponse.data.uid,
      accountId: activeAccountId,
      productNo: datahaulStudy.pn,
      weightType: weightList.wt,
      divisor: weightList.dv || 1000,
      weightChange: true,
    };

    if (crosstab.DataHaulBasesDataGridData && crosstab.DataHaulBasesDataGridData.length > 0) {
      const userStateData = this.generateGridData(crosstab, 'DataHaulBasesDataGridData');
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'BasesDataGrid',
        targetGrid: 'BasesDataGrid',
        expressionList: userStateData.selectedKeywords,
        selectedNames: userStateData.selectedNames,
        originalNames: userStateData.originalNames,
        recTypes: userStateData.recTypes,
        objSmartSearchArray: userStateData.dataSmartSearch,
      };
      this.props.getSampleWeighted(sampleWeightedParams);
    }

    if (crosstab.DataHaulColumnsDataGridData && crosstab.DataHaulColumnsDataGridData.length > 0) {
      const userStateData = this.generateGridData(crosstab, 'DataHaulColumnsDataGridData');
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'ColumnsDataGrid',
        targetGrid: 'ColumnsDataGrid',
        expressionList: userStateData.selectedKeywords,
        selectedNames: userStateData.selectedNames,
        originalNames: userStateData.originalNames,
        recTypes: userStateData.recTypes,
        objSmartSearchArray: userStateData.dataSmartSearch,
      };
      this.props.getSampleWeighted(sampleWeightedParams);
    }
  };

  generateGridData = (gridData, gridItem) => {
    const data = {
      selectedKeywords: [],
      selectedNames: [],
      originalNames: [],
      recTypes: [],
      dataSmartSearch: [],
    };
    gridData[gridItem].forEach(item => {
      data.selectedKeywords.push(item.keyword);
      data.selectedNames.push(item.title);
      data.originalNames.push(item.originalTitle);
      data.recTypes.push(item.recType || item.rectype || item.type);
      data.dataSmartSearch.push(item.dataSmartSearch);
    });
    return data;
  };

  render() {
    const { datahaulStudy, datahaulGridColumns, hideWeightType } = this.props;
    return (
      <div>
        <div>
          <div className="smart-search-editor">
            <div className="appBreadcrumb">
              <div className="crosstab-study-selector">
                <CommonStudySelector
                  studies={this.state.studies}
                  featureID={DATAHAUL_FEATUREID}
                  defaultStudy={this.state.defaultStudy}
                  dataOnScreen={this.checkSCTabHasData}
                  alertMsg={'This selection will impact all of the Crosstab modules'}
                  setMethod={this.setSelectedStudy}
                  resetMethod={click => (this.resetSelectedSCStudy = click)}
                  showWeightType={this.state.showWeightType}
                  handleChangeWeightType={this.handleChangeWeightType}
                  hideWeightType={hideWeightType}
                  menuName={DATAHAUL_CONSTANT}
                  style={{
                    fontWeight: 'bold',
                    color: '#4e0e28',
                  }}
                  selectedWeightType={this.props.datahaulWeightTypes}
                  getSampleWeightedDatahaul={this.getSampleWeightedDatahaul}
                />
              </div>
              <div className="essential-breadcrumb">
                <span className="parent">Essentials / </span>DataHaul
              </div>
            </div>
            <div className="clearfix">
              <SmartSearch
                toggleSearchEditor={this.props.toggleSearchEditor}
                selectedModule={DATAHAUL_CONSTANT}
                moduleStudy={datahaulStudy}
                getSampleWeighted={this.props.getSampleWeighted}
                fetchKPI={this.props.fetchKPI}
                gridData={this.props.gridData}
                runCrosstab={this.props.runCrosstab}
                runDataHaul={this.props.runDataHaul}
                dataScreen={this.props.dataScreen}
                ref={this.smartSearchBox}
                viewerGridType={
                  this.props.crosstabTableList &&
                  this.props.crosstabTableList.length > 0 &&
                  this.props.crosstabTableList[0].viewerGridType
                }
                trackerFn={this.props.trackerFn}
                isTagInputExpanded={this.state.isTagInputExpanded}
                resetAll={this.resetAll}
              />
              <div className="move-to-datahaul-wrapper">
                <div className="button-group">
                  <a
                    className="button square-button"
                    onMouseOver={this.mouseOver}
                    onMouseOut={this.mouseOut}
                    onClick={() =>
                      this.setState({
                        isTagInputExpanded: !this.state.isTagInputExpanded,
                      })
                    }
                  >
                    <div className="square">
                      {!this.state.isTagInputExpanded ? (
                        <img
                          src={enlargeIcon}
                          data-src={enlargeIcon}
                          data-hoversrc={enlargeHoverIcon}
                          alt="Expand Smart Search"
                          title="Expand Smart Search"
                        />
                      ) : (
                        <img
                          src={enlargeHoverIcon}
                          data-src={enlargeHoverIcon}
                          data-hoversrc={enlargeHoverIcon}
                          alt="Expand Smart Search"
                          title="Expand Smart Search"
                        />
                      )}
                      <span>EXPAND</span>
                    </div>
                  </a>

                  {((datahaulStudy && datahaulStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)) ||
                    this.state.baseBtnDisabled) ? (
                    <a className="button square-button" disabled>
                      <div className="square">
                        <img
                          src={basesDisabledIcon}
                          data-src={basesDisabledIcon}
                          data-hoversrc={basesDisabledIcon}
                          alt="Move to Bases"
                          title="Move to Bases"
                        />
                        <span>BASES</span>
                      </div>
                    </a>
                    ) : (
                    <a
                      className="button square-button"
                      onMouseOver={this.mouseOver}
                      onMouseOut={this.mouseOut}
                      onClick={() => this.handleDataHaulMove('DataHaulBasesDataGrid')}
                    >
                      <div className="square">
                        <img
                          src={basesIcon}
                          data-src={basesIcon}
                          data-hoversrc={basesHoverIcon}
                          alt="Move to Bases"
                          title="Move to bases"
                        />
                        <span>BASES</span>
                      </div>
                    </a>
                    )}
                  {this.state.colBtnDisabled ? (
                    <a className="button square-button" disabled>
                      <div className="square">
                        <img
                          src={columnsDisabledIcon}
                          data-src={columnsDisabledIcon}
                          data-hoversrc={columnsDisabledIcon}
                          alt="Move to Columns"
                          title="Move to columns"
                        />
                        <span className="move-to-column-label">COLUMN</span>
                      </div>
                    </a>
                  ) : (
                    <a
                      className="button square-button"
                      onMouseOver={this.mouseOver}
                      onMouseOut={this.mouseOut}
                      onClick={() => this.handleDataHaulMove('DataHaulColumnsDataGrid')}
                    >
                      <div className="square">
                        <img
                          src={columnsIcon}
                          data-src={columnsIcon}
                          data-hoversrc={columnsHoverIcon}
                          alt="Move to Columns"
                          title="Move to columns"
                        />
                        <span className="move-to-column-label">COLUMN</span>
                      </div>
                    </a>
                  )}
                  {datahaulGridColumns && datahaulGridColumns.length > 0 ? (
                    <a
                      className="button square-button"
                      onMouseOver={this.mouseOver}
                      onMouseOut={this.mouseOut}
                      onClick={() => {
                        this.setState({ isTagInputExpanded: false });
                        this.handleRunDataHaul();
                      }}
                    >
                      <div className="square">
                        <img
                          src={runIcon}
                          data-src={runIcon}
                          data-hoversrc={runHoverIcon}
                          alt="Run"
                          title="Run DataHaul"
                        />
                      </div>
                    </a>
                  ) : (
                    <a className="button square-button" disabled>
                      <div className="square">
                        <img
                          src={runDisabledIcon}
                          data-src={runDisabledIcon}
                          data-hoversrc={runDisabledIcon}
                          alt="Run"
                          title="Run DataHaul"
                        />
                      </div>
                    </a>
                  )}
                </div>
              </div>
            </div>
            <ResizeAware
              style={{ overflow: 'hidden', height: 'calc(100vh - 205px)' }}
              onResize={this.handleDataHaulGridResize}
            >
              <DataHaulGrid
                dataHaulGridWidth={this.state.dataHaulGridWidth}
                dataHaulGridHeight={this.state.dataHaulGridHeight}
                trackerFn={this.props.trackerFn}
              />
            </ResizeAware>
          </div>
        </div>
        <Modal
          title=""
          ref={node => (this.modalDataHaulBaseWarining = node)}
          dialogStyles={modalDataHaulWariningStyle}
        >
          <div className="text-center">
            <p>
              You are allowed to select only 1 base at a time.
              Please reduce the number of bases and run again.
            </p>
            <GenericButton
              name="Ok"
              btnStyle="button btn-cncl button-125px"
              onBtnClick={() => this.modalDataHaulBaseWarining.hide()}
            />
          </div>
        </Modal>
        <Modal
          title=""
          ref={node => (this.modalDataHaulColumnWarining = node)}
          dialogStyles={modalDataHaulWariningStyle}
        >
          <div className="text-center">
            <p>
              You have reached the maximum allowed 10 Columns for Data Mine.
              Please reduce the number of columns and run again.
            </p>
            <GenericButton
              name="Ok"
              btnStyle="button btn-cncl button-125px"
              onBtnClick={() => this.modalDataHaulColumnWarining.hide()}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

DataHaulSmartSearchEditor.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({}),
  }),
  activeAccountId: PropTypes.number,
  crosstabTableList: PropTypes.arrayOf(PropTypes.object),
  toggleSearchEditor: PropTypes.func,
  datahaulStudy: PropTypes.shape({}),
  getSampleWeighted: PropTypes.func,
  fetchKPI: PropTypes.func,
  gridData: PropTypes.shape({
    DataHaulColumnsDataGrid: PropTypes.arrayOf(PropTypes.object),
    DataHaulBasesDataGrid: PropTypes.arrayOf(PropTypes.object),
  }),
  runCrosstab: PropTypes.func,
  runDataHaul: PropTypes.func,
  dataScreen: PropTypes.string,
  study: PropTypes.shape({
    datahaulStudy: PropTypes.shape({}),
  }),
  trackerFn: PropTypes.func,
  handleStudyChange: PropTypes.func,
  studyActions: PropTypes.shape({
    updateModuleStudy: PropTypes.func,
  }),
  datahaulGridColumns: PropTypes.arrayOf(PropTypes.object),
  studies: PropTypes.arrayOf(PropTypes.object),
  kpiInfo: PropTypes.shape({}),
  hideWeightType: PropTypes.bool,
  datahaulWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    crosstabTableList: state.crosstab.crosstabTableList,
    study: state.study,
    studies: state.study.studies,
    crosstab: state.crosstab,
    datahaulStudy: state.study.datahaulStudy,
    kpiInfo: state.crosstab.kpiInfo,
    datahaulGridColumns: state.crosstab.DataHaulColumnsDataGridData,
    datahaulWeightTypes: state.study.datahaulWeightTypes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    studyActions: bindActionCreators(studyActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(DataHaulSmartSearchEditor);
